export default __webpack_public_path__ + "static/media/rocket_anim_71.4083eaff.png";